import { createServerFn } from '@tanstack/react-start'
import { getRequest } from '@tanstack/react-start/server'

export const getRefreshToken = createServerFn({ method: 'GET' }).handler(() => {
  const request = getRequest()
  const cookie = request.headers.get('cookie')
  if (!cookie) return null
  const match = cookie.match(/(?:^|;\s*)refresh_token=([^;]*)/)
  return match ? match[1] : null
})
